import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react'
import { AlertChip, AlertTypeChip } from '../../../components/Alert/AlertChip';
import { alertConfigType } from '../../../components/Alert/alert.config';


const useStyles = makeStyles({

    markdown: {

        "& ul": {

            fontSize: "12px",
        },
        "& li": {
            margin: "0px",
            padding: "0px",
            fontSize: "12px",
        },
        "& p": {
            padding: "0px 16px",
            fontSize: "12px",
        },
    }

});

export default function InformationBox({
    status,
    alertChipContent,
    contents
}: {

    alertChipContent?: {
        type: AlertTypeChip;
        label: string;
    },

    status?: AlertTypeChip;
    contents?: string;
}) {


    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
            }}
        >
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "space-between",
                marginBottom: "5px"
            }}
            >
                <AlertChip
                    type={alertChipContent?.type || "info"}
                    label={alertChipContent?.label || ""}
                    style={{ padding: 1 }}
                    textStyle={{
                        color: tokens.colorNeutralForeground1,
                        fontWeight: 500,
                    }}
                />
                {status && (
                    <AlertChip
                        type={status || "info" as alertConfigType}
                        label={status || "Clean"}
                    />
                )}
            </div>
            <div
                style={{
                    border: tokens.colorNeutralStroke1,
                    borderRadius: "8px",
                    backgroundColor: tokens.colorNeutralBackground3,
                    padding: "5px 0px",
                }}
            >
                <div
                    className={useStyles().markdown}
                    dangerouslySetInnerHTML={{ __html: contents || "" }}
                />
            </div>
        </div>
    )
}